import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { ArrowDownS16Icon, ArrowUpS16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import { ProfileNameBadge } from 'APP/components/ProfileNameBadge/ProfileNameBadge';
import { SystemMessageLayout } from 'APP/main/ChatView/Messages/Message/SystemMessageLayout/SystemMessageLayout';
import { useUserProfile } from 'APP/main/hooks/userProfile/useUserProfile';

import usePresenter from './presenter';
import styles from './styles.m.scss';

const Call = ({ message }) => {
  const presenter = usePresenter(message);
  const userProfile = useUserProfile(presenter.initiatorId, {
    groupId: message.groupId,
    messageId: message.id,
  });

  return (
    <SystemMessageLayout
      message={message}
      className={classNames(styles.wrapper, {
        [styles.left]: presenter.isLeftAligned,
      })}
    >
      <div className={styles.container}>
        <div className={styles.title}>
          {presenter.text.before}
          {presenter.isShowInitiator && (
            <button
              className={styles.initiator}
              onClick={userProfile.show}
            >
              <span className={styles.name}>{presenter.initiatorName}</span>
              <ProfileNameBadge
                verified={presenter.verified}
                inlineBadge
                source={presenter.userNameBadge?.source}
                animated={presenter.userNameBadge?.animated}
                displayUILayer={0}
              />
            </button>
          )}
          {presenter.text.after}
        </div>
        <div className={styles.meta}>
          <IconView
            Icon={presenter.isIncoming ? ArrowDownS16Icon : ArrowUpS16Icon}
            className={classNames(styles.icon, styles[presenter.reason])}
            size="small"
          />
          {presenter.time}
          {presenter.duration}
        </div>
      </div>
    </SystemMessageLayout>
  );
};

export default observer(Call);
